import React from 'react'
import Slider from 'components/common/Slick/Slider'
import * as Boxes from 'components/theme/Boxes'
import { Headline } from 'components/theme/Content'

import quote from 'images/testimonials/quote.svg';

export default ({ data }) => {

  return (
    <React.Fragment>
      <Headline className="center padding l" style={{ marginBottom: '3rem' }}>
        <h3 className="dark-blue">Témoignages clients</h3>
      </Headline>
      <Slider>
        {
          data.map((item, index) => {
            return (
              <Boxes.Testimonial key={`testimonial-${index}`}>
                <div>
                  <img src={quote} alt={`Témoignage de ${item.name}`} />
                  <blockquote>{item.text}</blockquote>
                </div>
                <div>
                  <div>
                    <h3>{item.name}</h3>
                    <span>{item.status}</span>
                  </div>
                </div>
              </Boxes.Testimonial>
            )
          })
        }
      </Slider>
    </React.Fragment>
  )
}
